// extracted by mini-css-extract-plugin
export default {"button":"AisLsJaE_AWnIhDlnTUV"};